export const m = {
	corporate:'超一科技',
  homepage: '主页',
  hardwareservices: '硬件设备',
  softwareservices: '软件定制',
  integratedsystem: '弱电集成系统',
  aboutus: '关于我们',
}


// WEBPACK FOOTER //
// ./src/common/lang/zh.js